import FiguresTooltip from '../FiguresTooltip';
import { Tooltip } from 'antd';

const NKTLeakage = props => {
    const { research, scale, minDepth, width, title, date, toDepth } = props;

    const { isInflow, fluid_type } = research;

    const bottom = toDepth(research.bottom);
    const roof = toDepth(research.roof);

    const height = (bottom - roof) * scale + 24;

    const style = {
        position: 'absolute',
        transform: `translateY(${Math.abs((minDepth - roof) * scale - scale + 12)}px)`,
    };

    const lineHeight = height;
    const topArrowPosition = 12;
    const middleArrowPosition = height / 2;
    const bottomArrowPosition = height - 12;
    const rightSkinnyLineHorizontalPosition = width - 26 + 0.5;
    const rightBoldLineHorizontalPosition = width - 0.5;

    if (isInflow) {
        return (
            <Tooltip
                title={
                    <FiguresTooltip
                        title={title}
                        roof={roof}
                        bottom={bottom}
                        date={date}
                        inFlow={isInflow}
                        fluid={fluid_type}
                    />
                }
                styles={{ root: { maxWidth: 'none' } }}
            >
                <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg" fill="none" style={style}>
                    <g>
                        <path
                            id="top_arrow"
                            fill="#7E8DA9"
                            d={`m22,${topArrowPosition}l-5,-2.88675l0,5.77355l5,-2.8868zm-4.5,-0.5l-15.5,0l0,1l15.5,0l0,-1z`}
                        />
                        <path
                            id="left_middle_arrow"
                            fill="#7E8DA9"
                            d={`m22,${middleArrowPosition}l-5,-2.8868l0,5.7736l5,-2.8868zm-4.5,-0.5l-15.5,0l0,1l15.5,0l0,-1z`}
                        />
                        <path
                            id="bottom_arrow"
                            fill="#7E8DA9"
                            d={`m22,${bottomArrowPosition}l-5,-2.8868l0,5.7736l5,-2.8868zm-4.5,-0.5l-15.5,0l0,1l15.5,0l0,-1z`}
                        />
                        <path
                            id="left_skinny_line"
                            fill="#7E8DA9"
                            d={`m25.5,0l0,${lineHeight}l1,0l0,-${lineHeight}l-1,0z`}
                        />
                        <path
                            id="left_bold_line"
                            fill="#7E8DA9"
                            d={`m0.5,0l0,${lineHeight}l3,0l0,-${lineHeight}l-3,0z`}
                        />
                        <path
                            id="right_middle_arrow"
                            fill="#7E8DA9"
                            d={`m${
                                rightSkinnyLineHorizontalPosition + 3
                            },${middleArrowPosition}l5,2.8868l0,-5.7736l-5,2.8868zm4.5,0.5l15.5,0l0,-1l-15.5,0l0,1z`}
                        />
                        <path
                            id="right_skinny_line"
                            fill="#7E8DA9"
                            d={`m${rightSkinnyLineHorizontalPosition},0l0,${lineHeight}l-1,0l0,-${lineHeight}l1,0z`}
                        />
                        <path
                            id="right_bold_line"
                            fill="#7E8DA9"
                            d={`m${rightBoldLineHorizontalPosition},0l0,${lineHeight}l-3,0l0,-${lineHeight}l3,0z`}
                        />
                    </g>
                </svg>
            </Tooltip>
        );
    }

    return (
        <Tooltip
            title={
                <FiguresTooltip
                    title={title}
                    roof={roof}
                    bottom={bottom}
                    date={date}
                    inFlow={isInflow}
                    fluid={fluid_type}
                />
            }
            styles={{ minWidth: 'fit-content' }}
        >
            <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg" fill="none" style={style}>
                <g>
                    <path
                        id="right_first_arrow"
                        fill="#7E8DA9"
                        d={`m${
                            rightBoldLineHorizontalPosition - 3
                        },${topArrowPosition}l-5,-2.88675l0,5.77355l5,-2.8868zm-4.5,-0.5l-15.5,0l0,1l15.5,0l0,-1z`}
                    />
                    <path
                        id="right_second_arrow"
                        fill="#7E8DA9"
                        d={`m${
                            rightBoldLineHorizontalPosition - 3
                        },${middleArrowPosition}l-5,-2.8868l0,5.7736l5,-2.8868zm-4.5,-0.5l-15.5,0l0,1l15.5,0l0,-1z`}
                    />
                    <path
                        id="right_third_arrow"
                        fill="#7E8DA9"
                        d={`m${
                            rightBoldLineHorizontalPosition - 3
                        },${bottomArrowPosition}l-5,-2.8868l0,5.7736l5,-2.8868zm-4.5,-0.5l-15.5,0l0,1l15.5,0l0,-1z`}
                    />
                    <path
                        id="right_skinny_line"
                        fill="#7E8DA9"
                        d={`m${rightSkinnyLineHorizontalPosition + 1},0l0,${lineHeight}l1,0l0,-${lineHeight}l-1,0z`}
                    />
                    <path
                        id="right_bold_line"
                        fill="#7E8DA9"
                        d={`m${rightBoldLineHorizontalPosition - 1},0l0,${lineHeight}l3,0l0,-${lineHeight}l-3,0z`}
                    />
                    <path
                        id="left_arrow"
                        fill="#7E8DA9"
                        d={`m6,${middleArrowPosition}l5,2.8868l0,-5.7736l-5,2.8868zm4.5,0.5l15.5,0l0,-1l-15.5,0l0,1z`}
                    />
                    <path
                        id="left_skinny_line"
                        fill="#7E8DA9"
                        d={`m26.5,0l0,${lineHeight}l-1,0l0,-${lineHeight}l1,0z`}
                    />
                    <path id="left_bold_line" fill="#7E8DA9" d={`m3.5,0l0,${lineHeight}l-3,0l0,-${lineHeight}l3,0z`} />
                </g>
            </svg>
        </Tooltip>
    );
};

export default NKTLeakage;
